import script from "./WebsiteSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./WebsiteSettings.vue?vue&type=script&setup=true&lang=js"

import "./WebsiteSettings.vue?vue&type=style&index=0&id=19a62660&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-19a62660"]])

export default __exports__